module.exports = __webpack_public_path__ + "img/NekologicSquare.ac97360c.png";